// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".force-overflow>div{text-overflow:ellipsis;white-space:nowrap;overflow:visible !important}.force-overflow>*{overflow:visible !important}.force-overflow>*>*{overflow:visible !important}.force-overflow>*>*>*{overflow:visible !important}", ""]);
// Exports
module.exports = exports;
